import { render, staticRenderFns } from "./SingleStudent.vue?vue&type=template&id=74f6d252&scoped=true&"
import script from "./SingleStudent.vue?vue&type=script&lang=ts&"
export * from "./SingleStudent.vue?vue&type=script&lang=ts&"
import style0 from "./SingleStudent.vue?vue&type=style&index=0&id=74f6d252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f6d252",
  null
  
)

export default component.exports